<ng-template [ngIf]="showChat">
  <!--All this element does is add space for the floating chat button-->
  <div id="spacer"></div>
</ng-template>
